module.exports = __webpack_public_path__ + "img/smooth-amaro.6890ab76.jpg";